import { Component, Input } from '@angular/core';

@Component({
  selector: 'pub-appointment-date-widget',
  templateUrl: './appointment-date-widget.component.html',
  styleUrls: ['./appointment-date-widget.component.scss'],
})
export class AppointmentDateWidgetComponent {
  @Input() date!: string;
}
